export const buildCompareOptions = ({ teacherModelName, versions = [], resultsFileName = null }) => {
  const opts = [];

  if (teacherModelName) {
    opts.push({
      label: teacherModelName,
      value: 'oldModel',
      type: 'teacher',
    });
  }

  if (resultsFileName) {
    opts.push({
      label: resultsFileName,
      value: 'file',
      type: 'results_file',
    });
  }

  const majorVersions = Array.from(
    new Set(
      (versions || [])
        .map((v) => Math.floor(Number(v)))
        .filter((v) => Number.isFinite(v))
    )
  ).sort((a, b) => b - a);

  majorVersions.forEach((v) => {
    opts.push({
      label: `v${v}`,
      value: v,
      type: 'optune',
    });
  });

  return opts;
};

